export default "__VITE_ASSET__qrPd6aDb__"